import { render } from "./BarChartStacked.vue?vue&type=template&id=1f9c1791"
import script from "./BarChartStacked.vue?vue&type=script&lang=js"
export * from "./BarChartStacked.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__